export enum IntervalEnum {
  TenMinutes = 1,
  Hour,
  Day,
  Week,
  Month
}
